import React from "react";
import Layout from "src/components/layout/website/Layout";

const AboutPage: React.FC = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-white py-20 px-6">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl font-bold text-indigo-600 mb-6">
            About Invyntra
          </h1>
          <p className="text-gray-600 mb-8 max-w-3xl mx-auto">
            Invyntra was built with a single mission — to make inventory
            management effortless for small and medium businesses. Our platform
            helps businesses automate stock tracking, sales, and purchase
            operations without the need for complex setups.
          </p>

          <div className="grid md:grid-cols-2 gap-10 mt-16 text-left">
            <div>
              <h2 className="font-semibold text-xl mb-2">Our Mission</h2>
              <p className="text-gray-600">
                To empower every business to handle inventory smarter — with
                real-time visibility, analytics, and automation that saves time
                and cost.
              </p>
            </div>
            <div>
              <h2 className="font-semibold text-xl mb-2">Our Story</h2>
              <p className="text-gray-600">
                Founded by engineers passionate about problem-solving, Invyntra
                grew from a simple dashboard to a full-scale SaaS trusted by
                multiple businesses across India.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AboutPage;
